import React from 'react'
import '../../App.css'
import Footer from '../Footer';
import Info from '../Info';

function AboutMe(){
    return(
    <>
        <h1 className='about-me'>ABOUT ME</h1>
        <Info />
        <Footer />
    </>
    );
}

export default AboutMe;